import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DeptSelectionModalComponent } from '../dept-selection-modal/dept-selection-modal.component';

@Component({
  selector: 'app-enhanced-dept-fields',
  standalone: false,
  templateUrl: './enhanced-dept-fields.component.html',
  styleUrls: ['./enhanced-dept-fields.component.scss'],
})
export class EnhancedDeptFieldsComponent implements OnInit {

  @Input() pageSpecificFormObject: any;
  @Input() departmentList: any[] = [];
  @Input() canUpdate: boolean = false;

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    console.log('EnhancedDeptFields - canUpdate:', this.canUpdate);
    console.log('EnhancedDeptFields - departmentList:', this.departmentList);
  }

  /**
   * Get array of selected department objects
   */
  getSelectedDepartments(): any[] {
    if (!this.pageSpecificFormObject?.departmentIds || !this.departmentList) {
      return [];
    }

    return this.departmentList.filter(dept =>
      this.pageSpecificFormObject.departmentIds.includes(String(dept.id))
    );
  }

  /**
   * Remove a single department from selection
   */
  removeDepartment(deptId: any): void {
    if (!this.pageSpecificFormObject?.departmentIds) {
      return;
    }

    const idString = String(deptId);
    // Create a new array to trigger change detection
    this.pageSpecificFormObject.departmentIds = this.pageSpecificFormObject.departmentIds.filter(
      id => id !== idString
    );
  }

  /**
   * Clear all department selections
   */
  clearAllDepartments(): void {
    if (this.pageSpecificFormObject) {
      this.pageSpecificFormObject.departmentIds = [];
    }
  }

  /**
   * Get count of selected departments
   */
  get selectedCount(): number {
    return this.pageSpecificFormObject?.departmentIds?.length || 0;
  }

  /**
   * Check if any departments are selected
   */
  get hasSelections(): boolean {
    return this.selectedCount > 0;
  }

  /**
   * Check if department list is empty
   */
  get hasDepartments(): boolean {
    return this.departmentList && this.departmentList.length > 0;
  }

  /**
   * Get label text for the field
   */
  get fieldLabel(): string {
    if (this.selectedCount > 0) {
      return `Department (${this.selectedCount} selected)`;
    }
    return 'Department';
  }

  /**
   * Open department selection modal
   */
  async openSelectionModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: DeptSelectionModalComponent,
      componentProps: {
        allDepartments: this.departmentList,
        selectedDepartmentIds: this.pageSpecificFormObject?.departmentIds || []
      },
      cssClass: 'dept-selection-modal',
      backdropDismiss: true
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm' && data) {
      // Update the form object with selected IDs
      this.pageSpecificFormObject.departmentIds = data.selectedIds;
      console.log('Departments updated:', data.selectedIds);
    }
  }

}
